import React from "react";

export default function RecaptchaNotice({ className = "" }) {
  return (
    <p
      className={`font-sans-ui text-[11px] leading-snug text-[var(--c4p-muted)] ${className}`}
      data-testid="recaptcha-notice"
    >
      Protected by reCAPTCHA —{" "}
      <a
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        Privacy
      </a>{" "}
      &{" "}
      <a
        href="https://policies.google.com/terms"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        Terms
      </a>
      .
    </p>
  );
}
